import { Checkbox as MuiCheckbox } from "@mui/material";

import { CHECKBOX_MUI_SIZE } from "ui/checkbox/checkbox.constants";
import { CheckboxLabel } from "ui/checkbox/checkbox.styles";
import { type CheckboxProps } from "ui/checkbox/checkbox.types";
import { useCheckbox } from "ui/checkbox/use-checkbox";

export const Checkbox = ({
  checked,
  onChange,
  size = "md",
  label,
  ref,
  sx,
  className,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  ...rest
}: CheckboxProps) => {
  const { hasLabel, handleChange } = useCheckbox({ label, onChange });

  const control = (
    <MuiCheckbox
      {...rest}
      className={hasLabel ? undefined : className}
      sx={hasLabel ? undefined : sx}
      checked={checked}
      onChange={handleChange}
      size={CHECKBOX_MUI_SIZE[size]}
      slotProps={{ input: { ref, "aria-label": ariaLabel, "data-testid": dataTestId } }}
    />
  );

  if (!hasLabel) {
    return control;
  }

  return (
    <CheckboxLabel
      checkboxSize={size}
      className={className}
      control={control}
      label={label}
      sx={sx}
    />
  );
};
